import FormattedDate from '@/features/common/components/FormattedDate';
import { InconsistentValue } from '@/features/maintenance-data/components/InconsistentValue';
import { MaintenanceDataItem } from '@/generated/GeneratedApiTypes';

const DAY_MONTH_YEAR_FORMAT: Intl.DateTimeFormatOptions = { day: '2-digit', month: '2-digit', year: 'numeric' };
const MONTH_YEAR_FORMAT: Intl.DateTimeFormatOptions = { month: '2-digit', year: 'numeric' };

const INCONSISTENT_DUE_AT_TOOLTIP =
    'intl-msg:vehicle-diagnostics.maintenance.table.maintenance-data.inconsistent-due-at';

export const DueAtCell = ({ row }: { row: MaintenanceDataItem }) => {
    const { due_at: dueAt } = row;
    if (!dueAt?.value) {
        return (
            <td data-field="due_at">
                <span>-</span>
            </td>
        );
    }
    const date = (
        <FormattedDate
            date={dueAt.value}
            dateFormat={dueAt.has_month_precision ? MONTH_YEAR_FORMAT : DAY_MONTH_YEAR_FORMAT}
        />
    );
    return (
        <td data-field="due_at">
            {dueAt.is_inconsistent ? (
                <InconsistentValue tooltipKey={INCONSISTENT_DUE_AT_TOOLTIP}>{date}</InconsistentValue>
            ) : (
                date
            )}
        </td>
    );
};
